import React, { useState } from "react";
import NotFound from "../../atom/notFound";
import Pagnation from "../../atom/pagination";
import Download from "./index";
import styles from "./downloadWithPagination.module.css";
import { useRouter } from "next/router";

const PER_PAGE = 9;

function DownloadCard(props) {
  const documentIconClassname = {
    excel: "xls.png",
    xml: "xml.png",
    pdf: "pdf.png",
  };

  const openPopUp = (name) => {
    if (props.showDownloadPopup) {
      props.showDownloadPopup(name);
    }
  };

  const hidePopUp = () => {
    props.hideDownloadPopup();
  };

  return (
    <div className={styles.downloadCard}>
      <div className={styles.leftSide}>
        <p className={styles.publishDate}>{props.publishDate}</p>
        <p className={styles.description}>{props.DocumentName} </p>
      </div>
      <div className={styles.rightSide}>
        <span className={styles.separator} />
        <div className={styles.documentIcon}>
          <img
            src={`/assets/images/download/${props.isEditable === 1 && props.fileType === "pdf"
                ? "Edit.svg"
                : documentIconClassname[props.fileType] || "pdf.png"
              }`}
            onClick={() => openPopUp(props.DocumentName)}
            width={54}
            height={54}
          />
        </div>
      </div>
      {props.optionShow === props.DocumentName ? (
        <div className={styles.downloadOption}>
          <div className={styles.downLoadOptionList}>
            <span className={styles.closeIcon} onClick={hidePopUp}></span>
            <a href={props.file} download target="_blank">
              <span>Download</span>
              <img
                src="/assets/images/download/cloud.svg"
                alt="cloud"
                width={35}
                height={35}
              />
            </a>
            <a href={props.file} target="_blank">
              <span>View</span>
              <img
                src="/assets/images/download/view.svg"
                alt="cloud"
                width={35}
                height={35}
              />
            </a>
            <a
              href={`https://wa.me/?text=${props.file}`}
              download
              target="_blank"
            >
              <span>Whatsapp</span>
              <img
                src="/assets/images/download/whatsapp.svg"
                alt="cloud"
                width={35}
                height={35}
              />
            </a>
            <a
              href={`mailto:?subject=Motilal Oswal Mutual Funds&body=Hi, I found this and looks intresting Have a look, ${props.file}`}
              download
              target="_blank"
            >
              <span>Email</span>
              <img
                src="/assets/images/download/email.svg"
                alt="cloud"
                width={35}
                height={35}
              />
            </a>
          </div>
        </div>
      ) : null}
    </div>
  );
}

function DownloadWithPagination(props) {
  const [currentPage, setCurrentPage] = useState(0);
  console.log("all data", props.data);
  const tabsToFilter = [
  "/download/leaflets-brochures",
  "/download/presentations",
  "/download/monthly-communique",
];
   const router = useRouter();

  // Assuming `apiData` is your API response array
const getLatestMonthData = (apiData = []) => {
  if (!Array.isArray(apiData) || apiData.length === 0) return [];

  const parsedData = apiData
    .map((item) => {
      if (!item.publishDate) return null;
      const [day, month, year] = item.publishDate.split("-").map(Number);

      const date = new Date(year, month - 1, day);

      if (isNaN(date)) return null;

      return {
        ...item,
        parsedDate: date,
      };
    })
    .filter(Boolean); // removes null entries

  if (parsedData.length === 0) return [];

  const latestDate = parsedData.reduce((latest, curr) =>
    curr.parsedDate > latest.parsedDate ? curr : latest
  ).parsedDate;

  const latestMonth = latestDate.getMonth();
  const latestYear = latestDate.getFullYear();

  return parsedData.filter(
    (item) =>
      item.parsedDate.getMonth() === latestMonth &&
      item.parsedDate.getFullYear() === latestYear
  );
};


// Usage
const latestData = getLatestMonthData(props.isFilter ? props?.filterList : props.data);


const listData = props.isFilter ? props?.filterList : props.data;

 const dataForDisplay = tabsToFilter.includes(router.asPath)
  ? latestData
  : listData;

  if (!dataForDisplay.length) {
    return (
      <div className="col-md-12  clearfix">
        <NotFound class="text center" msg="Not found" />
      </div>
    );
  }

  const offset = currentPage * PER_PAGE;
  const endOffset = offset + PER_PAGE;
  const pageCount = Math.ceil(dataForDisplay?.length / PER_PAGE);
  const isLayoutInList = props.layoutView === "list";
  const showPagination = dataForDisplay?.length > PER_PAGE;

  const handlePageClick = (data) => {
    setCurrentPage(data);
  };

  const cardBody = () => {
    const hideShowValue = {
      showDownloadPopup: props.showDownloadPopup,
      optionShow: props.optionShow,
      hideDownloadPopup: props.hideDownloadPopup,
    };

    if (isLayoutInList) {
      return (
        <div className="col-md-11">
          <div className={styles.downloadContainer}>
            {dataForDisplay.slice(offset, endOffset).map((curr, index) => (
              <DownloadCard key={index} {...curr} {...hideShowValue} />
            ))}
          </div>
          <div className={styles.paginationRight}>
            {showPagination ? (
              <Pagnation click={handlePageClick} pageCount={pageCount} currentPage={currentPage} />
            ) : null}
          </div>
        </div>
      );
    }

    return dataForDisplay
      .slice(offset, endOffset)
      .map((curr, index) => (
        <Download
          {...curr}
          key={index}
          date={curr.publishDate}
          docName={curr.DocumentName}
          file={curr.file}
          fileType={curr.fileType}
          isEditable={curr.isEditable}
          tabChange={props.tabChange}
          {...hideShowValue}
        />
      ));
  };

  return (
    <React.Fragment>
      {cardBody()}

      {!isLayoutInList ? (
        <div className={`col-md-12 ${styles.paginationRight}`}>
          {showPagination ? (
            <Pagnation click={handlePageClick} pageCount={pageCount} currentPage={currentPage} />
          ) : null}
        </div>
      ) : null}
    </React.Fragment>
  );
}

export default DownloadWithPagination;
